import classNames from "classnames";
import { useRef } from "react";
import { CaseBlock } from "../CaseBlock";
import { TCaseLocalState } from "../../../../types";
import { CaseComments } from "../CaseComments";
import styles from "./styles.module.css";
import { CaseCreatorHeader } from "../CaseCreatorHeader";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectCaseEntityMode } from "../../../../redux/selectors";

interface Props {
  caseState: TCaseLocalState;
  handleChangeField: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | string,
    path: string,
  ) => void;
  handleClickTip: (field: string, value: string) => void;
  isLocked?: boolean;
  className?: string;
}

export const CaseUpdater = (props: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const entityMode = useAppSelector(selectCaseEntityMode);

  return (
    <div className={classNames(styles.container)}>
      <CaseCreatorHeader />
      <div ref={scrollRef} className={styles["scroll-wrapper"]}>
        <div
          className={classNames(
            props.isLocked && styles["scroll-wrapper-locked"],
          )}
        >
          <div className={styles["case-block"]}>
            {entityMode === "agent" && (
              <div className={styles["agent-harness-title"]}>
                Заполните основные элементы обвязки агента
              </div>
            )}
            {props.caseState.map((caseBlock, index) => {
              return (
                <CaseBlock
                  key={`${index}-${caseBlock.blockTitle}`}
                  caseBlock={caseBlock}
                  handleClickTip={props.handleClickTip}
                  handleChangeField={props.handleChangeField}
                  className={props.className}
                />
              );
            })}
          </div>
          <CaseComments scrollRef={scrollRef} />
        </div>
      </div>
    </div>
  );
};
